@if (hasMarker && markerLabel) {
  <div class="label-row above">
    <span class="marker-label" [style.left.%]="percentOf(markerAt)">{{ markerLabel }}</span>
  </div>
}
<div class="track">
  <div class="fill" [class.progress]="tone === RepProgressBarTone.Progress" [style.left.%]="fillLeft" [style.width.%]="fillWidth"></div>
  @if (hasMarker) {
    <div class="marker" [style.left.%]="percentOf(markerAt)"></div>
  }
  @if (hasDot) {
    <div class="dot" [attr.data-tone]="dotTone" [style.left.%]="percentOf(dotAt)"></div>
  }
</div>
@if (showFillLabels) {
  <div class="label-row below">
    <!-- while merged, the single labels stay in place, hidden, so they can still be measured -->
    <span #fromLabel class="fill-label" [class.progress]="tone === RepProgressBarTone.Progress" [class.merged-away]="merged()"
      [attr.aria-hidden]="merged() ? 'true' : null" [style.left.%]="fillLeft">{{ fillFrom }}</span>
    <span #toLabel class="fill-label end" [class.progress]="tone === RepProgressBarTone.Progress" [class.merged-away]="merged()"
      [attr.aria-hidden]="merged() ? 'true' : null" [style.left.%]="percentOf(fillTo)">{{ fillTo }}</span>
    @if (merged()) {
      <span class="fill-label end" [class.progress]="tone === RepProgressBarTone.Progress" data-e2e-id="e2e-merged-fill-label"
        [style.left.%]="percentOf(fillTo)">{{ mergedLabelText }}</span>
    }
  </div>
}
